module.exports = __webpack_public_path__ + "static/img/040_2.e0b6eb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_2.jpg
// module id = xUs1
// module chunks = 1